import { Box, Paper, Typography, Button, Avatar, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

/* ✅ ALL RELIGION LOGOS */
const religionLogos = [
  { id: "om", name: "OM", src: "/religions/om2.png" },
  { id: "ganesh", name: "Ganesh", src: "/religions/jaiganesh.png" },
  { id: "ganesh2", name: "Ganesh", src: "/religions/Ganpati2.png" },
  { id: "buddha", name: "Buddha", src: "/religions/buddha2.png" },
  { id: "mahadev", name: "Mahadev", src: "/religions/mahadev2.png" },
  { id: "krishna", name: "Krishna", src: "/religions/krishna2.png" },
  { id: "balaji", name: "Balaji", src: "/religions/balaji2.png" },
  { id: "shree", name: "Shree", src: "/religions/shree.png" },
  { id: "ram", name: "Ram", src: "/religions/shreeram2.png" },

  // extra for popup
  { id: "crescent", name: "Islam", src: "/religions/allha.png" },
  { id: "khanda", name: "Sikh", src: "/religions/sikh.png" },
];

export default function ReligionAndPhotoSection({
  selectedReligionLogo,
  setSelectedReligionLogo,
  profileImage,
  setProfileImage,
}) {
  const [open, setOpen] = useState(false);

  /* ================= PHOTO ================= */
  const handleImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => setProfileImage(reader.result);
    reader.readAsDataURL(file);
  };

  const handleDeleteImage = () => setProfileImage(null);

  /* ================= LOGO ================= */
  const handleSelect = (logo) => {
    setSelectedReligionLogo(logo);
    setOpen(false);
  };

  const handleRemoveLogo = () => {
    setSelectedReligionLogo(null);
  };

  return (
    <>
      <Paper
        sx={{
          p: 2,
          mb: 2,
          borderRadius: 2,
          border: "1px solid #eee",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "65% 35%" },
            gap: 2,
            alignItems: "center",
          }}
        >
          {/* ================= LEFT ================= */}
          <Box>
            <Typography fontWeight={600} mb={1}>
              Religious Symbol
            </Typography>

            {/* Selected */}
            {selectedReligionLogo && (
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <Box
                  component="img"
                  src={selectedReligionLogo.src}
                  sx={{ width: 40, height: 40 }}
                />
                <Typography fontSize={14}>
                  {selectedReligionLogo.name}
                </Typography>

                <Button size="small" color="error" onClick={handleRemoveLogo}>
                  Remove
                </Button>
              </Box>
            )}

            {/* 8 LOGOS GRID */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: 1,
              }}
            >
              {religionLogos.slice(0, 8).map((logo) => {
                const selected = selectedReligionLogo?.id === logo.id;

                return (
                  <Box
                    key={logo.id}
                    onClick={() => handleSelect(logo)}
                    sx={{
                      cursor: "pointer",
                      p: 1,
                      borderRadius: 2,
                      border: selected
                        ? "2px solid #f57c00"
                        : "1px solid #ddd",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: 70,
                      background: "#fafafa",
                      transition: "0.2s",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={logo.src}
                      sx={{
                        width: 55,
                        height: 55,
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                );
              })}
            </Box>

            {/* SHOW MORE */}
            <Button size="small" sx={{ mt: 1 }} onClick={() => setOpen(true)}>
              Show More
            </Button>
          </Box>

          {/* ================= RIGHT (PHOTO) ================= */}
          <Box textAlign="center">
            <Typography fontWeight={600} mb={1}>
              Profile Photo
            </Typography>

            <Avatar
              src={profileImage || ""}
              sx={{
                width: 110,
                height: 110,
                mx: "auto",
                mb: 1,
                border: "1px solid #ddd",
              }}
            />

            <Button variant="outlined" component="label" size="small">
              Upload
              <input
                hidden
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
              />
            </Button>

            {profileImage && (
              <Button
                size="small"
                color="error"
                onClick={handleDeleteImage}
                sx={{ mt: 1 }}
              >
                Remove Photo
              </Button>
            )}
          </Box>
        </Box>
      </Paper>

      {/* ================= POPUP ================= */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <Box p={2}>
          <Box display="flex" justifyContent="space-between">
            <Typography fontWeight={600}>
              Select Religious Symbol
            </Typography>

            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(4,1fr)",
              gap: 2,
              mt: 2,
            }}
          >
            {religionLogos.map((logo) => (
              <Box
                key={logo.id}
                onClick={() => handleSelect(logo)}
                sx={{
                  cursor: "pointer",
                  p: 1,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  textAlign: "center",
                  "&:hover": { background: "#f5f5f5" },
                }}
              >
                <Box
                  component="img"
                  src={logo.src}
                  sx={{ width: 60, height: 60 }}
                />
                <Typography fontSize={12}>{logo.name}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Dialog>
    </>
  );
}